module.exports = shared.lazyloader;